// storage.ts
const writeTime = new Date().getTime();
const myStorage = {
  setStore: (key: string, value: any, expire: number = 100 * 60 * 60 * 60 * 1000) => {
    const obj = {
      key,
      value,
      writeTime,
      expire
    };
    if (process.client) {
      sessionStorage.setItem(key, JSON.stringify(obj));
    }

  },
  getStore: (key: string) => {
    const val = process.client ? sessionStorage.getItem(key) : null;
    if (val === null || typeof val === 'undefined') {
      return null;
    }
    const res = JSON.parse(val);
    const readTime = new Date().getTime();
    if (((readTime - res.writeTime) / 1000) * 60 * 60 * 24 > res.expired) {
      // 数据过期 清除数据
      if (process.client) {
        sessionStorage.removeItem(key);
      }

      return null;
    } else {
      // console.log(readTime - res.writeTime)
      return res.value;
    }
  },
  delStore: (key: string) => {
    if (key && process.client) {
      sessionStorage.removeItem(key);
    }
  },
  delStoreAll() {
    //删除所有值
    window.sessionStorage.clear();
  }
};
export default myStorage;
